import { Box, Text } from '@air/zephyr';
import { Document } from '@contentful/rich-text-types';

import { VideoData } from '~/lib/contentful/custom-types';
import { Video } from '~/old-marketing/components//Video';
import { Container } from '~/old-marketing/components/Container';
import { AdobeWaitlistForm } from '~/old-marketing/components/forms/AdobeWaitlistForm';
import { Section, SECTION_CMS_LINK_CLASS_NAME } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { usePreviewMode } from '~/providers/PreviewModeProvider';

const TEMPLATE_KEY = 'adobe-splash-cta';

export type AdobeSplashCTASectionTemplateProps = {
  content?: Document;
  isSubsection?: boolean;
  id: string;
  title?: string;
  videos?: VideoData[];
};

export const AdobeSplashCTASectionTemplate = ({
  content,
  isSubsection,
  id,
  title,
  videos,
}: AdobeSplashCTASectionTemplateProps) => {
  const { isPreview } = usePreviewMode();
  const video = videos?.[0];

  return (
    <Section
      css={{
        position: 'relative',
        paddingTop: 0,
        paddingBottom: 156,
      }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Container>
        <Box tx={{ maxWidth: 760, mx: 'auto', textAlign: 'center' }}>
          {title && (
            <SectionTitle css={{ marginBottom: 36, color: '$jay150' }} isSubsection={isSubsection} size="heading-56">
              {title}
            </SectionTitle>
          )}

          {content && <SectionContent content={content} css={{ marginBottom: 48, color: '$pigeon200' }} size="ui-20" />}
        </Box>

        {video && (
          <SectionFieldTooltip field="Videos" isPreview={isPreview}>
            <Box>
              <Video
                className={isPreview ? SECTION_CMS_LINK_CLASS_NAME : ''}
                details={{
                  height: video.height,
                  width: video.width,
                }}
                poster={video.poster.file.url}
                sources={video.types.map((type) => ({
                  src: type.file.url,
                  type: type.file.contentType,
                }))}
                tx={{ marginBottom: 80 }}
              />
            </Box>
          </SectionFieldTooltip>
        )}

        <Text
          tx={{
            maxWidth: 608,
            marginX: 'auto',
            marginBottom: 40,
            color: 'pigeon200',
            fontSize: 'clamp(16px, 1.66vw, 24px)',
            fontWeight: 'medium',
            textAlign: 'center',
          }}
          variant="text-ui-24"
        >
          Join the waitlist to access to Air’s remote video collaboration system.
        </Text>

        <AdobeWaitlistForm tx={{ maxWidth: 504, marginX: 'auto' }} />
      </Container>
    </Section>
  );
};

AdobeSplashCTASectionTemplate.templateKey = TEMPLATE_KEY;
